"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutBase_1 = require("./ShortcutBase");
var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");
var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");
var PortfolioCorrelationShortcut = /** @class */ (function (_super) {
    __extends(PortfolioCorrelationShortcut, _super);
    function PortfolioCorrelationShortcut(scenarioStatisticQuery) {
        return _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.portfolioCorrelation, shortcuts_1.ShortcutType.rootOptions, scenarioStatisticQuery) || this;
    }
    PortfolioCorrelationShortcut.prototype.getRootOptions = function (shortcutOptions) {
        var _a = shortcutOptions.options, options = _a === void 0 ? {} : _a;
        var response = this.scenarioStatisticQuery.shortcuts.portfolio.getRootOptions(__assign(__assign({}, shortcutOptions), { options: {
                portfolio: {
                    key: 'correlation',
                    options: {
                        correlation: options.portfolioCorrelation,
                    },
                },
            } }));
        return response;
    };
    return PortfolioCorrelationShortcut;
}(ShortcutBase_1.ShortcutBase));
exports.PortfolioCorrelationShortcut = PortfolioCorrelationShortcut;
//# sourceMappingURL=PortfolioCorrelationShortcut.js.map